import React from "react";
import "../../css/MainPage/MainLanding.css";

import headerpic from "../../assets/header-images/headerpic.png";
import prep1 from "../../assets/header-images/prep1.jpg";

import Roadmap1 from "../../assets/header-images/Roadmap1.jpg";
import Paths1 from "../../assets/header-images/Paths1.jpg";
import major1 from "../../assets/header-images/major1.jpg";
import collegesearch1 from "../../assets/header-images/collegesearch1.jpg";
import hsplanning from "../../assets/header-images/hsplanning.jpg";
import ccpathway from "../../assets/header-images/ccpathway.jpg";
import achievements from "../../assets/header-images/achievements.jpg";
import navigating1 from "../../assets/header-images/navigating1.jpg";
import essaycraft1 from "../../assets/header-images/essaycraft1.jpg";
import recletter from "../../assets/header-images/recletter.jpg";
import international from "../../assets/header-images/international.jpg";
import afford1 from "../../assets/header-images/afford1.jpg";

import TrafficBox from "../../components/TrafficBox";
import HeaderSection from "../../components/HeaderSection";
import PageIntro from "../../components/PageIntro";

const trafficBoxData = [
  {
    partNumber: "1",
    title: "High School Road Map",
    description:
      "Guidance and resources for high school students preparing for college. Includes steps to succeed in high school, specific scholarships, extracurricular activities, AP courses, direct college applications, academic support, test prep, college planning, course selection, summer programs, and time management & study skills.",
    image: Roadmap1,
    link: "/college-prep/highschool-roadmap",
  },
  {
    partNumber: "2",
    title: "Exploring Different Paths",
    description:
      "Explore various pathways to college, including direct applications from high school, starting at a community college, and more. Learn about the benefits and challenges of each path to make an informed decision.",
    image: Paths1,
    link: "/college-prep/different-paths",
  },
  {
    partNumber: "3",
    title: "Choosing a Major",
    description:
      "Tools and resources to help you choose and explore majors. Includes a major quiz, exploration of various majors, career paths, coursework overview, and guidance on how to choose the correct major.",
    image: major1,
    link: "/college-prep/majors",
  },
  {
    partNumber: "4",
    title: "College Search",
    description:
      "Information on how to search for colleges, including comparisons between in-state vs out-of-state and public vs private institutions.",
    image: collegesearch1,
    link: "/college-prep/college-search-guide",
  },
  {
    partNumber: "5",
    title: "Highschool Planning",
    description:
      "Guidance and resources for high school students preparing for college. Includes steps to succeed in high school, specific scholarships, extracurricular activities, AP courses, direct college applications, academic support, test prep, college planning, course selection, summer programs, and time management & study skills.",
    image: hsplanning,
    link: "/college-prep/high-school",
  },
  {
    partNumber: "6",
    title: "Community College Pathways",
    description:
      "Comprehensive guide for community college students planning to transfer to a four-year institution. Includes steps to succeed in community college, specific scholarships, extracurricular activities, transfer applications, transfer statistics, and benefits of starting at a community college.",
    image: ccpathway,
    link: "/college-prep/community-college",
  },
  {
    partNumber: "7",
    title: "Activities and Achievements",
    description:
      "Showcasing your activities and achievements is key to a strong college application. This chapter guides you on effectively highlighting your extracurriculars, leadership roles, and accomplishments to give admissions a clear view of your potential.",
    image: achievements,
    link: "/college-prep/activities-and-achievements",
  },
  {
    partNumber: "8",
    title: "Navigating the Application Process",
    description:
      "Tips and guidance on the college application process. Includes deadlines, requirements, application tips, admission tests (SAT, ACT), types of applications, essay writing steps, and financial aid & scholarship guidance.",
    image: navigating1,
    link: "/college-prep/application-process",
  },
  {
    partNumber: "9",
    title: "Crafting Your College Essay",
    description:
      "Detailed steps for writing college application essays, including UC and Common App essays. Tips on drafting, revising, and polishing your essays to make them stand out.",
    image: essaycraft1,
    link: "/college-prep/college-essay",
  },
  {
    partNumber: "10",
    title: "Letters of Recommendation",
    description:
      "Guide on securing strong recommendation letters, including whom to ask, how to ask, and what information to provide to your recommenders.",
    image: recletter,
    link: "/college-prep/recommendation-letters",
  },
  {
    partNumber: "11",
    title: "International Student Guide",
    description:
      "Comprehensive guide for international students considering U.S. colleges, including application requirements, standardized tests, visa information, and financial considerations.",
    image: international,
    link: "/college-prep/international-students",
  },
  {
    partNumber: "12",
    title: "Affording Your Education",
    description:
      "Resources and strategies for financing your college education, including scholarships, grants, loans, and work-study programs.",
    image: afford1,
    link: "/afford-college",
  },
];

const introText =
  "This section provides a comprehensive guide to help you prepare for college through various pathways. Whether you're a high school student, a community college student, or exploring different majors and careers, you'll find valuable information and resources here to support your journey. Click on each category to explore detailed information and take advantage of the tools and advice provided.";

const CollegePrep = () => {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${prep1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>College Prep</h1>
          <div className="main-landing-hero-sub">
            Your comprehensive guide to preparing for college success.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <p>{introText}</p>
        </div>
      </div>

      {/* Main Sections */}
      <div style={{ background: "#f8fafc", padding: "3.5rem 0" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
            gap: "2.2rem",
            maxWidth: 1100,
            margin: "0 auto",
            padding: "0 1.5rem",
          }}
        >
          {trafficBoxData.map((box, idx) => (
            <a
              key={idx}
              href={box.link}
              className="afford-college-card"
              style={{ textDecoration: "none" }}
            >
              <div className="afford-college-card-image">
                <img src={box.image} alt={box.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">{box.title}</div>
                  <div className="afford-college-card-desc">
                    {box.description}
                  </div>
                </div>
                <div
                  className="afford-college-link-btn"
                  style={{ width: "fit-content" }}
                >
                  Learn More
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CollegePrep;
